import { gql } from '@/__generated__';

export const GET_CONFIGURABLE_FIELDS_FOR_PREFERRED_UNITS = gql(`#graphql
  query ConfigurableFieldsForPreferredUnits {
    configurableFieldsForPreferredUnits {
      groupName
      affectedMetrics
    }
  }
`);
